import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    toolsWindowX: 0,
    toolsWindowsY: 0,
    currentEvents: true,
    futureEvents: true,
    filterValue: ""
  },
  mutations: {
    SET_CURRENT(state, currentEvents) {
      state.currentEvents = currentEvents;
    },
    SET_FUTURE(state, futureEvents) {
      state.futureEvents = futureEvents;
    },
    SET_FILTER(state, filterValue){
      state.filterValue = filterValue;
    }
  },
  actions: {
    READ_AIR_SENSORS({ commit, dispatch }, scope) {
      axios
        .get("/IOCNext/api/spatial/aq_sensors", {
          // params: {
          //   boundaries: scope
          // }
        })
        .then(response => {
          console.log("++++readed objects");
          commit("SET_AIR_SENSORS", response.data);
        })
        .catch(error => console.log(error));
    }
  },
  modules: {}
});
